// extracted by mini-css-extract-plugin
export var localeSelector = "_76-0";